import { AppBar, IconButton, Stack } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import Iconify from 'src/components/iconify';
import { useThemeSettingsContext } from 'src/components/settings/ThemeSettingsContext';
import { Action } from 'src/features/ActionsBar/shared/types';
import { useActionBarState } from 'src/features/ActionsBar/useActionBarState';
import { useChatAIContextState } from 'src/features/ChatAI';
import { NavButtons } from 'src/layouts/shared/NavButtons/NavButtons';
import { StyledToolbar } from 'src/layouts/shared/StyledToolbar/StyledToolbar';
import { useIsAppCollaborate } from 'src/state';

type Props = {
  onOpenNav: VoidFunction;
};

export const MobileBar = ({ onOpenNav }: Props) => {
  const theme = useTheme();
  const { headerColor } = useThemeSettingsContext();
  const isAppCollaborate = useIsAppCollaborate();

  const { isOpen, setIsOpen, openAction, setOpenAction } = useActionBarState();

  const { toggleChat } = useChatAIContextState((s) => ({
    isChatOpen: s.isChatOpen,
    toggleChat: s.toggleChat,
  }));

  const toggleOpenAction = (action: Action) => {
    if (openAction === action) {
      setIsOpen(false);
      toggleChat(false);
    } else {
      setOpenAction(action);
    }
  };

  return (
    <AppBar
      sx={{
        position: 'relative',
        boxShadow: 'none',
        zIndex: theme.zIndex.appBar + 1,
        width: 1,
        background: theme.palette[headerColor.color][headerColor.level],
        color: theme.palette.primary.contrastText,
        justifyContent: 'center',
      }}
    >
      <StyledToolbar>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width={1}
        >
          <IconButton
            onClick={onOpenNav}
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              border: `1px solid ${alpha(theme.palette.common.white, 0.24)}`,
            }}
          >
            <Iconify icon="tabler:baseline-density-medium" color="white" />
          </IconButton>
          <Stack direction="row" alignItems="center" gap={1}>
            <NavButtons />
          </Stack>
          {!isAppCollaborate && (
            <IconButton
              onClick={() => toggleOpenAction('openai')}
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1,
                border: `1px solid ${alpha(theme.palette.common.white, 0.24)}`,
                ...(isOpen && {
                  backgroundColor: theme.palette.action.selected,
                }),
              }}
            >
              <Iconify icon="tabler:sparkles" color="white" />
            </IconButton>
          )}
        </Stack>
      </StyledToolbar>
    </AppBar>
  );
};
